"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Range = exports.RANGE_HANDLE_SIZE = void 0;
var _themeGet = require("@styled-system/theme-get");
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _utils = require("../../utils");
var _remapValue = require("../../utils/remapValue");
var _Box = require("../Box");
var _Flex = require("../Flex");
var _excluded = ["ariaLabels", "min", "max", "step", "value", "onChange"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RANGE_HANDLE_SIZE = 24;
exports.RANGE_HANDLE_SIZE = RANGE_HANDLE_SIZE;
var Range = function Range(_ref) {
  var ariaLabels = _ref.ariaLabels,
    min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [0, max] : _ref$value,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var minRef = (0, React.useRef)(null);
  var maxRef = (0, React.useRef)(null);
  var _useState = (0, React.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var _useState3 = (0, React.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    maxWidth = _useState4[0],
    setMaxWidth = _useState4[1];
  var handleMinChange = function handleMinChange(_ref2) {
    var value = _ref2.target.valueAsNumber;
    if (value > values[1] - step) return;
    setValues([value, values[1]]);
    onChange === null || onChange === void 0 ? void 0 : onChange([value, values[1]]);
  };
  var handleMaxChange = function handleMaxChange(_ref3) {
    var value = _ref3.target.valueAsNumber;
    if (value < values[0] + step) return;
    setValues([values[0], value]);
    onChange === null || onChange === void 0 ? void 0 : onChange([values[0], value]);
  };
  (0, React.useEffect)(function () {
    var handleResize = function handleResize() {
      if (!maxRef.current) return;
      setMaxWidth(maxRef.current.offsetWidth);
    };
    requestAnimationFrame(handleResize);
    window.addEventListener("resize", handleResize, {
      passive: true
    });
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Sync local state with value prop
  (0, _utils.useUpdateEffect)(function () {
    setValues(value);
  }, _toConsumableArray(value));
  var selectionRectangle = "rect(0, ".concat((0, _remapValue.remapValue)(values[1], {
    min: min,
    max: max
  }, {
    min: 0,
    max: maxWidth - RANGE_HANDLE_SIZE
  }), "px, 2px, ").concat((0, _remapValue.remapValue)(values[0], {
    min: min,
    max: max
  }, {
    min: 0,
    max: maxWidth - RANGE_HANDLE_SIZE
  }), "px)");
  var maxRectangle = "rect(0, ".concat(maxWidth, "px, ").concat(RANGE_HANDLE_SIZE, "px, ").concat((0, _remapValue.remapValue)(values[1], {
    min: min,
    max: max
  }, {
    min: 0,
    max: maxWidth - RANGE_HANDLE_SIZE
  }), "px)");
  return /*#__PURE__*/React.createElement(Track, rest, /*#__PURE__*/React.createElement(Selection, {
    style: {
      clip: selectionRectangle
    }
  }), /*#__PURE__*/React.createElement(Slider, {
    ref: minRef,
    min: min,
    max: max,
    step: step,
    onInput: handleMinChange,
    value: values[0],
    "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels[0]
  }), /*#__PURE__*/React.createElement(Slider, {
    ref: maxRef,
    min: min,
    max: max,
    step: step,
    onInput: handleMaxChange,
    value: values[1],
    style: {
      clip: maxRectangle
    },
    "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels[1]
  }));
};
exports.Range = Range;
Range.displayName = "Range";
var Track = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Range__Track",
  componentId: "sc-si9a6m-0"
})(["align-items:center;position:relative;height:", "px;&:before{content:\"\";display:block;position:absolute;height:2px;left:0;right:0;top:50%;margin-top:-1px;background-color:", ";}"], RANGE_HANDLE_SIZE, (0, _themeGet.themeGet)("colors.black30"));
var Selection = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Range__Selection",
  componentId: "sc-si9a6m-1"
})(["position:absolute;height:2px;left:0;right:0;top:50%;margin-top:-1px;background-color:", ";"], (0, _themeGet.themeGet)("colors.brand"));
var railStyles = (0, _styledComponents.css)(["width:100%;height:", "px;"], RANGE_HANDLE_SIZE);
var handleStyles = (0, _styledComponents.css)(["user-select:none;cursor:grab;width:", "px;height:", "px;background-color:", ";border-radius:50%;border:1px solid ", ";box-shadow:", ";"], RANGE_HANDLE_SIZE, RANGE_HANDLE_SIZE, (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("effects.flatShadow"));
var Slider = _styledComponents.default.input.withConfig({
  displayName: "Range__Slider",
  componentId: "sc-si9a6m-2"
})(["appearance:none;background:transparent;position:relative;margin:0;width:100%;position:absolute;top:0;left:0;&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}&::-webkit-slider-thumb{-webkit-appearance:none;", "}&::-moz-range-thumb{", "}&:active{&::-webkit-slider-thumb{box-shadow:none;background-color:", ";}&::-moz-range-thumb{box-shadow:none;background-color:", ";}}"], railStyles, railStyles, handleStyles, handleStyles, (0, _themeGet.themeGet)("colors.black5"), (0, _themeGet.themeGet)("colors.black5"));
Slider.defaultProps = {
  type: "range"
};
//# sourceMappingURL=Range.js.map